module.exports = __webpack_public_path__ + "d6d7351cd165ed7fb766cd6603c9add1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-18.png
// module id = 3142
// module chunks = 0